import { ClickFormsAdjustmentGridFieldsMap } from '../../types.ts';

export const FNMA1004_TOTAL_ROWS = 559;
export const FNMA1004_SALES_COMP_GRID_ROWS_PER_COMP = 60;

export const FNMA1004_ADJUSTMENT_FIELDS: ClickFormsAdjustmentGridFieldsMap = {
  salePrice: 275,
  saleFinanceAdj: 280,
  concAdj: 282,
  dateOfSaleAdj: 284,
  locationAdj: 286,
  propRightsAdj: 288,
  siteAdj: 290,
  viewAdj: 292,
  designAdj: 294,
  qualityAdj: 296,
  actualAgeAdj: 298,
  conditionAdj: 300,
  aboveGradeAdj: 301,
  roomCountAdj: 305,
  glaAdj: 307,
  basementLine1Adj: 309,
  basementLine2Adj: 311,
  funcUtilAdj: 313,
  heatingCoolingAdj: 315,
  energyEffAdj: 317,
  garageCarportAdj: 319,
  porchPatioAdj: 321,
  blank1Adj: 323,
  blank2Adj: 325,
  blank3Adj: 327,
};

export const FNMA1004_ROWS = {
  SU_BLANK1_LABEL: 266,
  SU_BLANK2_LABEL: 268,

  // COST APPROACH
  CA_SUPPORT_FOR_SITE_VALUE: 498,
  CA_REPRODUCTION_CHECKBOX: 499,
  CA_REPLACEMENT_COST_NEW_CHECKBOX: 500,
  CA_COST_DATA_SOURCE: 501,
  CA_QUALITY: 502,
  CA_EFFECTIVE_DATE: 503,
  CA_COMMENTS: 504,
  CA_ESTIMATED_REMAINING_ECON_LIFE: 505,
  CA_OPINION_OF_SITE_VALUE: 506,
  CA_DWELLING_SQFT: 507,
  CA_DWELLING_COST_PER_SQFT: 508,
  CA_DWELLING_COST: 509,
  CA_OTHER1_LABEL: 510,
  CA_OTHER1_SQFT: 511,
  CA_OTHER1_COST_PER_SQFT: 512,
  CA_OTHER1_COST: 513,
  CA_OTHER2: 514,
  CA_OTHER2_COST: 515,
  CA_GARAGE_CARPORT_SQFT: 516,
  CA_GARAGE_CARPORT_COST_PER_SQFT: 517,
  CA_GARAGE_CARPORT_COST: 518,
  CA_TOTAL_ESTIMATE_OF_COST_NEW: 519,
  CA_DEPR_PHYS: 521,
  CA_DEPR_FUNC: 523,
  CA_DEPR_EXTN: 525,
  CA_DEPR_TOTAL: 526,
  CA_DEPR_COST_OF_IMPROVEMENTS: 527,
  CA_AS_IS_SITE_IMPROVEMENTS: 528,
  CA_INDICATED_VALUE: 529,
  CA_EFFECTIVE_AGE: 139,
};
